import MenuItem from "@mui/material/MenuItem";
import React from "react";
import TextField from "components/common/DTextField";

export default function SelectFieldRenderer({
    field,
    form,
    setForm,
    errors,
    showValidation
}) {
    const onChange = (event) =>
        setForm((prev) => ({
            ...prev,
            [field.name]: event.target.value
        }));

    return (
        <TextField
            select
            fullWidth
            margin="normal"
            label={field.label}
            value={form[field.name] ?? ""}
            required={field.required}
            error={showValidation && !!errors[field.name]}
            helperText={showValidation ? (errors[field.name] ?? "") : ""}
            onChange={onChange}
            disabled={field.disabled}
            // sx={{ marginBottom: "unset", marginTop: "unset", margin: "4px" }}
        >
            {field?.options &&
                field.options.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                    </MenuItem>
                ))}
        </TextField>
    );
}
